import React from 'react';
type LayoutProps = {
  children: React.ReactNode;
};
export function Layout({
  children
}: LayoutProps) {
  return <div className="w-full min-h-screen bg-gray-50 p-4 sm:p-6 md:p-8" data-id="element-48">
      <div className="max-w-7xl mx-auto" data-id="element-49">{children}</div>
    </div>;
}